import { authRef } from 'config'
import * as mixpanel from 'mixpanel-browser'

import { action } from '../../dispatchAction'
import { USER_ACTION_TYPES } from '../types'
// import { ChildrenList } from 'pages/ChildrenList'

export const logout = (
  successCallback: () => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async dispatch => {
  try {
    dispatch(action(USER_ACTION_TYPES.logout_begins))
    const uid = authRef.currentUser?.uid
    await authRef.signOut()
    sessionStorage.clear()

    // after authRef.signOut() all Listeners (User and Child will be detached automatically), so we don't need to subscribe them

    // we don't reset to null (it's not unsubscribe) ChildListener form context here because
    // if user signOut even from on of child page (questionairre, game or map) it will still exist with value but
    // after signIn you user will redirect to childrenList page where this ChildListener in context will be reset to null)

    dispatch(action(USER_ACTION_TYPES.logout_success))

    // !mixpanel stuff needed to be separated into appropriate action
    mixpanel.identify(uid)
    mixpanel.track('Signed out')
    mixpanel.reset()
    // !end of mixpanel stuff

    successCallback()
  } catch (e) {
    const { code, message } = e
    dispatch(action(USER_ACTION_TYPES.logout_error, { code, message }))
    errorCallback(message)
  }
}



// WEBPACK FOOTER //
// ./src/store/user/actions/logout.action.ts